import { Component, ChangeDetectionStrategy } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";


@Component({
    selector: 'app-info',
  imports: [
    NgOptimizedImage,
    NgOptimizedImage
  ],
    templateUrl: './info.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './info.component.scss'
})
export class InfoComponent {

}
